import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type Props = {
  icon: ReactNode;
  /** Tint for the round icon background, e.g. "bg-[#EFF6FF]". */
  iconBgClass?: string;
  title: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
};

/** Row card for the Calls tab: round tinted icon, call path, status line and right-side actions. */
export function CallRowCard({ icon, iconBgClass, title, meta, actions }: Props) {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-[#E5E7EB] bg-white px-4 py-3.5">
      <div
        className={cn(
          "flex h-10 w-10 shrink-0 items-center justify-center rounded-full",
          iconBgClass || "bg-[#F3F4F6]",
        )}
      >
        {icon}
      </div>
      <div className="min-w-0 flex-1 py-0.5">
        <div className="min-w-0">{title}</div>
        {meta ? <div className="mt-1 min-w-0">{meta}</div> : null}
      </div>
      {actions ? (
        <div
          className="flex shrink-0 items-center [&_button]:h-8 [&_button]:w-8 [&_button]:p-0 [&_button:hover]:bg-transparent"
          onClick={(e) => e.stopPropagation()}
        >
          {actions}
        </div>
      ) : null}
    </div>
  );
}
